<style lang="less" scoped>
@import "../../assets/css/table-list.css";
.btn-group {
  padding-left: 20px;
}
.ivu-radio-wrapper {
  font-size: 12px;
  margin-left: 10px;
}
.t-table {
  width: 100%;
  text-align: center;
  border-collapse: collapse;
  border-spacing: 0;
  td,
  th {
    word-break: break-all;
    word-wrap: break-word;
    border: 1px solid #dcdee2;
    padding: 10px 0;
    font-weight: normal;
    position: relative;
  }
}
.inline-block {
  display: inline-block;
}
</style>
<style>
.ivu-table-cell .ivu-btn {
  margin-right: 2px;
  margin-bottom: 5px;
}
</style>
<template>
  <div>
    <Card>
      <h3 class="title">合同列表管理</h3>
      <div class="margin-bottom-10 header-group">
        <Select v-model="params.CondList[0].Key" @on-change="change_condList">
          <Option v-for="item in d_search_data" :value="item.value">{{ item.label }}</Option>
        </Select>
        <div
          class="inline-block"
          v-if="params.CondList[0].Key=='c.SignDate' || params.CondList[0].Key=='c.EndDate'"
        >
          <DatePicker type="date" placeholder="请选择日期" @on-change="change_date"></DatePicker>
          <Select v-model="params.CondList[0].Operator" style="width: 150px;">
            <Option value="<=">小于等于输入时间</Option>
            <Option value=">=">大于等于输入时间</Option>
          </Select>
        </div>
        <div class="inline-block" v-else>
          <Input v-model="params.CondList[0].Value" placeholder="请输入搜索内容" />
        </div>
        <Button type="primary" @click="search">查询</Button>
        <Button type="primary" @click="to_addPage" class="right">新增</Button>
        <Button type="primary" @click="to_export" class="btn-right" :loading="loading_export">导出</Button>
        <Button
          type="primary"
          @click="to_export('all')"
          class="btn-right"
          :loading="loading_export_all"
        >导出全部</Button>
      </div>
      <div>
        <Table
          ref="selection"
          :columns="d_columns"
          border
          :data="d_data"
          @on-selection-change="get_select_data"
        ></Table>
        <div class="margin-top-20">
          <Page
            :total="d_total"
            show-sizer
            show-total
            @on-change="flip"
            @on-page-size-change="change_size"
            class="pull-right"
          ></Page>
          <div class="clear-both"></div>
        </div>
      </div>
    </Card>
    <Modal v-model="d_modal_stop" title="合同终止" footer-hide>
      <div>
        <div class="padding20 text-center fs14">
          <p>
            合同终止到：
            <DatePicker
              type="date"
              :value="d_stop_date"
              placeholder="请选择合同终止日期"
              style="width: 200px"
              @on-change="change_stop_date"
            ></DatePicker>
          </p>
        </div>
        <div>
          <Button @click="stop_modal_cancel" class="right margin-left10">取消</Button>
          <Button type="primary" @click="handle_stop" class="right">确认终止</Button>
          <div class="clear-both"></div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import apiContract from "../../api/contract.js";
export default {
  name: "leaseContract_page",
  data() {
    return {
      d_total: 0,
      d_page: 1,
      d_page_size: 10,
      d_search: null,
      d_search_data: [
        {
          value: "c.SerialNum",
          label: "合同编号",
        },
        {
          value: "c.Name",
          label: "合同名称",
        },
        {
          value: "c.BPartyName",
          label: "乙方名称",
        },
        {
          value: "c.Agent",
          label: "经办人",
        },
        {
          value: "c.SignDate",
          label: "签约日期",
        },
        {
          value: "c.EndDate",
          label: "到期日期",
        },
        {
          value: "c.Notes",
          label: "备注",
        },
      ],
      d_columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
          fixed: "left",
        },
        {
          title: "合同编号",
          key: "SerialNum",
          minWidth: 140,
          fixed: "left",
        },
        {
          title: "合同名称",
          key: "Name",
          minWidth: 180,
        },
        {
          title: "乙方名称",
          key: "BPartyName",
          minWidth: 180,
        },
        {
          title: "应收总金额",
          key: "TotalMoney",
          minWidth: 180,
        },
        {
          title: "租赁合同面积/m²",
          key: "Area",
          minWidth: 130,
        },
        {
          title: "状态",
          key: "State",
          minWidth: 100,
        },
        {
          title: "经办人",
          key: "Agent",
          minWidth: 100,
        },
        {
          title: "签约日期",
          key: "SignDate",
          minWidth: 140,
        },
        {
          title: "到期日期",
          key: "EndDate",
          minWidth: 140,
        },
        {
          title: "备注",
          key: "Notes",
          minWidth: 120,
          ellipsis: true,
        },
        {
          title: "操作",
          key: "do",
          fixed: "right",
          width: 210,
          render: (h, params) => {
            let btns = [];
            params.row.State === "待执行" &&
              btns.push(
                h(
                  "Button",
                  {
                    props: { type: "primary", size: "small" },
                    on: {
                      click: () => {
                        this.to_editPage(params.row);
                      },
                    },
                  },
                  "修改"
                ),
                h(
                  "Button",
                  {
                    props: { size: "small" },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: "提示",
                          content: "<p>您确认要开启该合同吗？</p>",
                          onOk: () => {
                            this.to_setState(params.row.SerialNum, "执行中");
                          },
                          onCancel: () => {},
                        });
                      },
                    },
                  },
                  "执行"
                ),
                h(
                  "Button",
                  {
                    props: { size: "small" },
                    on: {
                      click: () => {
                        this.to_detailPage(params.row);
                      },
                    },
                  },
                  "查看"
                ),
                h(
                  "Button",
                  {
                    props: { type: "primary", size: "small" },
                    on: {
                      click: () => {
                        this.to_prevSerial(params.row);
                      },
                    },
                  },
                  "续签"
                )
              );
            params.row.State === "执行中" &&
              btns.push(
                h(
                  "Button",
                  {
                    props: { type: "primary", size: "small" },
                    on: {
                      click: () => {
                        this.to_editPage(params.row);
                      },
                    },
                  },
                  "修改"
                ),
                h(
                  "Button",
                  {
                    props: { type: "error", size: "small" },
                    on: {
                      click: () => {
                        this.to_stop(params.row);
                      },
                    },
                  },
                  "终止"
                ),
                h(
                  "Button",
                  {
                    props: { size: "small" },
                    on: {
                      click: () => {
                        this.to_detailPage(params.row);
                      },
                    },
                  },
                  "查看"
                ),
                h(
                  "Button",
                  {
                    props: { type: "primary", size: "small" },
                    on: {
                      click: () => {
                        this.to_prevSerial(params.row);
                      },
                    },
                  },
                  "续签"
                )
              );
            params.row.State === "已终止" &&
              btns.push(
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: "提示",
                          content: "<p>您确认要关闭该合同吗？</p>",
                          onOk: () => {
                            this.to_setState(params.row.SerialNum, "已关闭");
                          },
                          onCancel: () => {},
                        });
                      },
                    },
                  },
                  "关闭"
                ),
                h(
                  "Button",
                  {
                    props: { size: "small" },
                    on: {
                      click: () => {
                        this.to_detailPage(params.row);
                      },
                    },
                  },
                  "查看"
                ),
                h(
                  "Button",
                  {
                    props: { type: "primary", size: "small" },
                    on: {
                      click: () => {
                        this.to_prevSerial(params.row);
                      },
                    },
                  },
                  "续签"
                )
              );
            params.row.State === "已关闭" &&
              btns.push(
                h(
                  "Button",
                  {
                    props: { size: "small" },
                    on: {
                      click: () => {
                        this.to_detailPage(params.row);
                      },
                    },
                  },
                  "查看"
                )
              );
            return h(
              "div",
              {
                style: {
                  paddingTop: "5px",
                },
              },
              btns
            );
          },
        },
      ],
      d_data: [],
      d_del_data: [],
      params: {},
      d_stop_date: "",
      d_modal_stop: false,
      d_account: {
        Invoice: 0, // 已开票账户
        NoInvoice: 0, // 未开票账户
        Middle: 0, // 代收账户
      },
      end_params: {
        DepositMoney: 0,
        RentMoney: 0,
        WaterMoney: 0,
        OtherMoney: 0,
      },
      end_judge_params: {
        DepositMoney: "",
        RentMoney: "",
        WaterMoney: "",
        OtherMoney: "",
      },
      loading_export: false,
      loading_export_all: false,
    };
  },
  methods: {
    search() {
      this.params.PageIndex = 1;
      this.pull_data();
    },
    change_date(date) {
      this.params.CondList[0].Value = date;
    },
    change_stop_date(date) {
      this.d_stop_date = date;
    },
    change_condList(value) {
      if (value == "c.SignDate" || value == "c.EndDate") {
        this.params.CondList[0].Operator = "<=";
      } else {
        this.params.CondList[0].Operator = "like";
      }
    },

    flip(page) {
      //翻页条件，每页多少条，多少页
      this.params.PageIndex = page;
      this.params.PageSize = this.d_page_size;
      this.pull_data();
    },
    change_size(size) {
      //改变limit 每页显示多少条
      this.params.PageSize = size;
      this.pull_data();
    },
    pull_data() {
      let _this = this;
      apiContract.getList.post(this.params).then((_data) => {
        if (_data.data.ExeSuccess && _data.data.LoginSuccess) {
          let requestResult = _data.data.Data;
          let RowsList = requestResult.RowsList;
          for (let i = 0; i < RowsList.length; i++) {
            RowsList[i].TotalMoney = RowsList[i].TotalMoney + " 元";
          }
          _this.d_data = RowsList;
          _this.d_total = requestResult.Total;
        } else {
          this.$Message.error(_data.data.Msg);
        }
      });
    },
    to_addPage() {
      this.$router.push(`/leaseAdd_page/add`);
    },
    to_prevSerial(row) {
      //续签合同
      this.$router.push(`/leaseAdd_page/prev&${row.SerialNum}`);
    },
    get_select_data(row) {
      let delData = "";
      for (let i = 0; i < row.length; i++) {
        delData += row[i].ID + ",";
      }
      delData =
        delData.substring(delData.length - 1) == ","
          ? delData.substring(0, delData.length - 1)
          : delData; // 去掉末尾逗号
      this.d_del_data = delData;
    },
    to_editPage(row) {
      this.$router.push(`/leaseAdd_page/edit&${row.SerialNum}`);
    },
    to_detailPage(row) {
      localStorage.setItem("keyName", this.params.CondList[0].Key);
      localStorage.setItem("keyValue", this.params.CondList[0].Value); //存储方便返回的时候使用
      this.$router.push(`/leaseDetail_page/${row.SerialNum}`);
    },
    to_stop(row) {
      this.d_modal_stop = true;
      apiContract.getContractEndDto(row.SerialNum).then((_data) => {
        if (_data.data.ExeSuccess && _data.data.LoginSuccess) {
          this.end_params = _data.data.Data;
          this.end_params.id = row.SerialNum; // 保存终止合同的id
        } else {
          this.$Message.error(_data.data.Msg);
        }
      });
      // apiContract.getContractAccount(row.SerialNum).then((_data) => {
      //   if(_data.data.ExeSuccess && _data.data.LoginSuccess){
      //     this.d_account = _data.data.Data;
      //   }else {
      //     this.$Message.error(_data.data.Msg);
      //   }
      // });
    },
    handle_stop() {
      let serialNum = this.end_params.id;
      let date = this.d_stop_date;
      if (date) {
        this.to_setState(serialNum, "已终止", date);
      } else {
        this.$Message.error("终止日期必须填写！");
      }
    },
    to_setState(_id, _state, _date) {
      let params = {
        ID: _id,
        state: _state,
      };
      if (_date) {
        params.date = _date;
      }
      apiContract.setState.post(params).then((_data) => {
        if (_data.data.ExeSuccess && _data.data.LoginSuccess) {
          this.$Message.success("状态修改成功");
          this.d_modal_stop = false;
          this.pull_data();
        } else {
          this.$Message.error(_data.data.Msg);
        }
      });
    },
    stop_modal_cancel() {
      this.d_modal_stop = false;
    },
    to_export(_type) {
      //导出
      // let condList = this.params.CondList[0];
      // if(condList.Value ===''){
      //   delete this.params.CondList;
      // }
      let _this = this;
      if (_type === "all") {
        this.params.PageIndex = 1;
        this.params.PageSize = 10000000;
        this.loading_export_all = true;
      } else {
        this.loading_export = true;
      }
      apiContract.export.post(this.params).then((_data) => {
        console.log(_data);
        if (_data.data) {
          setTimeout(function () {
            _this.loading_export = false;
            _this.loading_export_all = false;
          }, 1000);
          let blob = _data.data;
          let reader = new FileReader();
          reader.readAsDataURL(blob); // 转换为base64，可以直接放入a表情href
          reader.onload = function (e) {
            // 转换完成，创建一个a标签用于下载
            let a = document.createElement("a");
            a.download = "合同列表.xlsx";
            a.href = e.target.result;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          };
        } else {
          this.$Message.error("导出报表出问题");
        }
      });
    },
  },
  computed: {},
  created() {
    this.params = JSON.parse(JSON.stringify(apiContract.getList.data));
    this.params.CondList[0].Key = localStorage.getItem("keyName") || "c.Name";
    this.params.CondList[0].Operator = "like";
    this.params.CondList[0].Value = localStorage.getItem("keyValue") || "";
    this.params.token = sessionStorage.getItem("token");
    this.pull_data();
  },
};
</script>
